var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useMemo, useState, useEffect } from 'react';
import { makeStyles, DialogContent, Dialog, Paper, FormGroup, FormControlLabel, Checkbox as MuiCheckbox, Typography, } from '@material-ui/core';
import { usePhoneView, IconButton } from '@michelin/acid-components';
import CloseIcon from '@material-ui/icons/Close';
import { get } from 'lodash';
import { useTranslation } from 'react-i18next';
import { GLOBAL_SEARCH_ITEMS, } from '../../types/GlobalSearch';
import SearchBar from './SearchBar/SearchBar';
import Hits from './Hits/Hits';
var useStyles = makeStyles(function (theme) {
    var _a;
    return ({
        container: {
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            height: '100%',
        },
        dialogContent: {
            padding: 0,
            display: 'flex',
            flexDirection: 'column',
            '&:first-child': {
                paddingTop: 0,
            },
        },
        closeButton: {
            position: 'absolute',
            right: 0,
            padding: '10px',
            color: theme.palette.grey[500],
            zIndex: 1200,
        },
        dialogPaper: (_a = {},
            _a[theme.breakpoints.up('sm')] = {
                position: 'absolute',
                top: '15%',
            },
            _a[theme.breakpoints.down('xs')] = {
                width: '100%',
                margin: 0,
                position: 'absolute',
                top: 0,
            },
            _a),
        dialogPaperOpen: {
            height: '60%',
        },
    });
});
var Checkbox = function (_a) {
    var checked = _a.checked, onChange = _a.onChange, label = _a.label;
    return (React.createElement(FormControlLabel, { control: React.createElement(MuiCheckbox, { checked: checked, color: "primary", style: { transform: 'scale(0.8)' }, onChange: onChange }), label: React.createElement(Typography, { variant: "caption" }, label) }));
};
var GlobalSearchDialog = function (_a) {
    var _b;
    var onClose = _a.onClose, results = _a.results, onSearchTerm = _a.onSearchTerm, searchLoading = _a.searchLoading;
    var classes = useStyles();
    var t = useTranslation().t;
    var phoneView = usePhoneView();
    var _c = __read(useState(''), 2), searchTerm = _c[0], setSearchTerm = _c[1];
    var _d = __read(React.useState((_b = {},
        _b[GLOBAL_SEARCH_ITEMS.FLEET_ORDER_ITEM] = false,
        _b[GLOBAL_SEARCH_ITEMS.URBAN_ORDER_ITEM] = false,
        _b[GLOBAL_SEARCH_ITEMS.CONTACT_ITEM] = false,
        _b[GLOBAL_SEARCH_ITEMS.MECHANICAL_CARE_ITEM] = false,
        _b[GLOBAL_SEARCH_ITEMS.ONCALL_ITEM] = false,
        _b)), 2), selected = _d[0], setSelected = _d[1];
    var handleClose = function (event, reason) {
        if (reason && reason === 'backdropClick' && phoneView)
            return;
        onClose();
    };
    var fleetOrders = get(results, GLOBAL_SEARCH_ITEMS.FLEET_ORDER_ITEM, []);
    var urbanOrders = get(results, GLOBAL_SEARCH_ITEMS.URBAN_ORDER_ITEM, []);
    var contacts = get(results, GLOBAL_SEARCH_ITEMS.CONTACT_ITEM, []).filter(function (c) { return c !== null && c.first_name && c.last_name; });
    var mechanical = get(results, GLOBAL_SEARCH_ITEMS.MECHANICAL_CARE_ITEM, []);
    var onCallCases = get(results, GLOBAL_SEARCH_ITEMS.ONCALL_ITEM, []);
    var hasResults = !!results && Object.keys(results).length > 0
        && (fleetOrders.length > 0 || urbanOrders.length > 0 || contacts.length > 0 || mechanical.length > 0 || onCallCases.length > 0);
    var filteredResults = useMemo(function () {
        var _a;
        return (_a = {},
            _a[GLOBAL_SEARCH_ITEMS.FLEET_ORDER_ITEM] = fleetOrders,
            _a[GLOBAL_SEARCH_ITEMS.URBAN_ORDER_ITEM] = urbanOrders,
            _a[GLOBAL_SEARCH_ITEMS.CONTACT_ITEM] = contacts,
            _a[GLOBAL_SEARCH_ITEMS.MECHANICAL_CARE_ITEM] = mechanical,
            _a[GLOBAL_SEARCH_ITEMS.ONCALL_ITEM] = onCallCases,
            _a);
    }, [results]);
    var setSelectedItem = function (key) {
        var _a;
        setSelected(__assign(__assign({}, selected), (_a = {}, _a[key] = !selected[key], _a)));
    };
    var onSearchTermChange = function (term) {
        setSearchTerm(term);
    };
    var selectedFilters = useMemo(function () {
        var s = [];
        Object.keys(selected).forEach(function (key) {
            if (selected[key]) {
                s.push(key);
            }
        });
        return s;
    }, [selected]);
    useEffect(function () {
        onSearchTerm(searchTerm, selectedFilters);
    }, [searchTerm, selectedFilters]);
    return (React.createElement(Dialog, { open: true, onClose: handleClose, fullWidth: true, classes: { paper: "".concat(classes.dialogPaper, " ").concat(hasResults && !phoneView ? classes.dialogPaperOpen : '') }, maxWidth: "md", fullScreen: phoneView && hasResults },
        React.createElement(DialogContent, { classes: { root: classes.dialogContent } },
            React.createElement(Paper, { className: classes.container },
                phoneView
                    && (React.createElement(IconButton, { "aria-label": "Close", className: classes.closeButton, onClick: onClose },
                        React.createElement(CloseIcon, null))),
                React.createElement(SearchBar, { isOpen: !!results, onSearchTerm: onSearchTermChange, searchLoading: searchLoading }),
                React.createElement(FormGroup, { row: true, style: { marginLeft: '10px' } },
                    React.createElement(Checkbox, { checked: selected[GLOBAL_SEARCH_ITEMS.URBAN_ORDER_ITEM], onChange: function () { return setSelectedItem(GLOBAL_SEARCH_ITEMS.URBAN_ORDER_ITEM); }, label: t('Urban Orders') }),
                    React.createElement(Checkbox, { checked: selected[GLOBAL_SEARCH_ITEMS.FLEET_ORDER_ITEM], onChange: function () { return setSelectedItem(GLOBAL_SEARCH_ITEMS.FLEET_ORDER_ITEM); }, label: t('Fleet Orders') }),
                    React.createElement(Checkbox, { checked: selected[GLOBAL_SEARCH_ITEMS.CONTACT_ITEM], onChange: function () { return setSelectedItem(GLOBAL_SEARCH_ITEMS.CONTACT_ITEM); }, label: t('Contacts') }),
                    React.createElement(Checkbox, { checked: selected[GLOBAL_SEARCH_ITEMS.ONCALL_ITEM], onChange: function () { return setSelectedItem(GLOBAL_SEARCH_ITEMS.ONCALL_ITEM); }, label: t('ONCall Cases') }),
                    React.createElement(Checkbox, { checked: selected[GLOBAL_SEARCH_ITEMS.MECHANICAL_CARE_ITEM], onChange: function () { return setSelectedItem(GLOBAL_SEARCH_ITEMS.MECHANICAL_CARE_ITEM); }, label: t('Mechanical Care Cases') })),
                !searchLoading && !!results && React.createElement(Hits, { hasResults: hasResults, results: filteredResults })))));
};
export default GlobalSearchDialog;
//# sourceMappingURL=GlobalSearchDialog.js.map